export const PERISCOPE_ENTITY_COPY = {
	IS_LOOKUP_OF_OBJECT: (name: string, objectName: string): string => `${name} is a lookup of the ${objectName} object`
};
